import { isRequired, isValidEmail } from '@helpers/validator';

const schema = {
  email: {
    type: 'text',
    errorMessage: ['errors.common.required', 'errors.common.invalidEmail'],
    isValid: [(value) => isRequired(value), (value) => isValidEmail(value)],
  },
  password: {
    type: 'text',
    errorMessage: ['errors.password.required'],
    isValid: [(value) => isRequired(value)],
  },
};

export default schema;
